import {useEffect, useRef, useState} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {defaultCreateAppData, ICreateAppData} from './IAppModels'
import {StepperComponent} from '../../../assets/ts/components'
import {KTIcon} from '../../../helpers'
import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {Step3} from './steps/Step3'
import {Step4} from './steps/Step4'
import {Step5} from './steps/Step5'
import {Step6} from './steps/Step6'
import {useNavigate} from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {useAuth} from '../../../../app/modules/auth'
import {IPatientData} from '../../interface/IPatientData'
import moment from 'moment'
import {IoClose} from 'react-icons/io5'
import {FaArrowRight, FaArrowLeft} from 'react-icons/fa'
// Cast icons as any to fix TypeScript errors
const CloseIcon = IoClose as any
const RightArrowIcon = FaArrowRight as any
const LeftArrowIcon = FaArrowLeft as any

type Props = {
  show: boolean
  handleClose: () => void
  onSuccessSubmit?: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({show, handleClose, onSuccessSubmit}: Props) => {
  const user = useAuth()
  const {auth} = useAuth()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<ICreateAppData>(defaultCreateAppData)
  const [claimValidationLoading, setClaimValidationLoading] = useState(false)
  const [errorMessageClaim, setErrorMessageClaim] = useState<string | null>(null)
  const [hasError, setHasError] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [curStep, setCurStep] = useState(0)

  const [patientData, setPatientData] = useState<IPatientData | null>(null)

  // State Manage Each Validation Stepper
  const [globalValidation, setGlobalValidation] = useState(false) //global validation
  const [isPatientDataFetched, setIsPatientDataFetched] = useState(false) //step 1
  const [isFormulirDataFetched, setIsFormulirDataFetched] = useState(false) //step 2
  const [isKetentuanDataFetched, setIsKetentuanDataFetched] = useState(false) //step 3
  const [isSelesaiDataFetched, setIsSelesaiDataFetched] = useState(false) //step 4
  const [isClaimValidation, setIsClaimValidation] = useState(false) // step 1 after isPatientDataFetched

  const [exclusionMessage, setExclusionMessage] = useState('')
  const [exclusionMessageBenefit, setExclusionMessageBenefit] = useState('')

  const [isStep2Valid, setIsStep2Valid] = useState(false)
  const [isStep3Valid, setIsStep3Valid] = useState(false)
  const [isStep6Valid, setIsStep6Valid] = useState(false)

  // Reset data when modal is closed
  useEffect(() => {
    if (!show) {
      setData(defaultCreateAppData) // Reset to initial data
      setHasError(false)
      setCurrentStep(0)
      setCurStep(0)
      setIsPatientDataFetched(false)
      setIsFormulirDataFetched(false)
      // setIsKetentuanDataFetched(false);
      setIsSelesaiDataFetched(false)
      setIsStep2Valid(false)
      // setIsStep3Valid(false);
      setIsStep6Valid(false)
    }
  }, [show])

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const updateData = (fieldsToUpdate: Partial<ICreateAppData>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentStep(stepper.current?.currentStepIndex || 0)
  }

  const nextStep = async () => {
    if (currentStep == 2) {
      const isValid = await validateExclusionProduct()
      if (!isValid) {
        return
      } else {
        setExclusionMessage('')
        setExclusionMessageBenefit('')
      }
    }
    setHasError(false)
    if (!stepper.current) {
      return
    }

    stepper.current.goNext()
    setCurrentStep(stepper.current?.currentStepIndex || 0)
  }

  // const nextStep = async () => {
  //   if (currentStep == 3) {
  //     const isValid = await validateExclusionProduct()
  //     if (!isValid) {
  //       return
  //     } else {
  //       setExclusionMessage('')
  //       setExclusionMessageBenefit('')
  //     }
  //   }
  //   setHasError(false)
  //   if (!stepper.current) {
  //     return
  //   }

  //   stepper.current.goNext()
  //   setCurrentStep(stepper.current?.currentStepIndex || 0)
  // }

  const handlePatientDataFetchSuccess = (fetchedPatientData: IPatientData) => {
    setIsPatientDataFetched(true)
    setPatientData(fetchedPatientData)
  }

  const handleClaimValidationSuccess = (isValid: boolean) => {
    setIsClaimValidation(isValid)
  }

  const handlePatientDataFetchError = () => {
    setIsPatientDataFetched(false)
    setPatientData(null)
  }

  const handleStep2ValidationSuccess = () => {
    setIsStep2Valid(true)
  }

  const handleStep2ValidationError = () => {
    setIsStep2Valid(false)
  }

  const handleStep3ValidationSuccess = () => {
    setIsStep3Valid(true)
  }

  const handleStep3ValidationError = () => {
    setIsStep3Valid(false)
  }

  const handleStep6ValidationSuccess = () => {
    setIsStep6Valid(true)
  }

  const handleStep6ValidationError = () => {
    setIsStep6Valid(false)
  }

  const fetchValidateClaim = async (cardNumber?: string): Promise<boolean> => {
    // const cardToValidate = cardNumber || inputCardNo
    const cardToValidate = cardNumber || data.appBasic.identification || patientData?.cardNumber

    console.log('data.appBasic.identification', data.appBasic.identification)
    console.log('cardNumber', cardNumber)
    console.log('cardToValidate', cardToValidate)
    setClaimValidationLoading(true)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/CreateClaimValidation?CardNumber=${cardToValidate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok || response.status !== 200) {
        handleClaimValidationSuccess && handleClaimValidationSuccess(false)
        setErrorMessageClaim(`Member memiliki klaim aktif*. Silakan hubungi Helpline AXA Financial Indonesia di 021-30019292 untuk informasi lebih lanjut.
          (*Klaim aktif adalah klaim non tunai yang belum selesai)`)
        return false // Return false for validation failure
      }

      if (response.ok) {
        handleClaimValidationSuccess && handleClaimValidationSuccess(true)
        setErrorMessageClaim(null) // Clear error message on successful validation
        return true // Return true for validation success
      }
    } catch (error) {
      console.log('Error fetching patient data:', error)
      handleClaimValidationSuccess && handleClaimValidationSuccess(false)
      // Check if the error is a SyntaxError
      if (error instanceof SyntaxError) {
        // Handle specific syntax errors
        if (error.message.includes("Unexpected token 'T'")) {
          setErrorMessageClaim(`Member memiliki klaim aktif*. Silakan hubungi Helpline AXA Financial Indonesia di 021-30019292 untuk informasi lebih lanjut.
(*Klaim aktif adalah klaim non tunai yang belum selesai)`)
        }
      } else {
        setErrorMessageClaim('An unexpected error occurred')
      }
      return false // Return false for validation failure
    } finally {
      setClaimValidationLoading(false)
    }
    return false // Default return false
  }

  const submit = async () => {
    const currentDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSS')

    // First, validate the claim before proceeding
    try {
      setLoading(true)

      // Call existing fetchValidateClaim function
      const cardToValidate = data.appBasic.identification
      const isValid = await fetchValidateClaim(cardToValidate)

      console.log('isValid', isValid)

      // If validation fails, stop the process
      if (!isValid) {
        toast.error(errorMessageClaim || 'Validation failed')
        setLoading(false)
        return
      }

      // If validation succeeds, continue with the submission process
      // Define the request body with proper typing
      interface RequestBody {
        id: number
        providerCode?: string
        providerName?: string
        providerEmail?: string
        providerAddress?: string
        providerCity?: string
        claimDate: string
        polyCode: string
        polyName: string
        doctor: string
        phone: string
        claimSource: string
        claimType: string
        statusClaim: string
        stPost: boolean
        stPaid: boolean
        stExgratia: boolean
        stHighPlan: boolean
        createdBy?: string
        idBenefit?: number
        benefitCode?: string
        benefitName?: string
        member: any
        benefitDetail: any
        treatmentType?: string
        plannedTreatmentDate?: string
        indate?: string
      }

      const requestBody: RequestBody = {
        id: 0,
        providerCode: user.currentUser?.providerCode,
        providerName: user.currentUser?.providerName,
        providerAddress: user.currentUser?.providerAddress,
        providerCity: user.currentUser?.providerCity,
        claimDate: currentDate,
        polyCode: '',
        polyName: '',
        doctor: '',
        phone: data.appBasic.phoneNumber,
        claimSource: 'CASHLESS',
        claimType: 'Web Provider',
        // statusClaim: 'Registered',
        statusClaim:
          data.appBasic.jenisPerawatan === 'Perawatan Auth' ? 'Pre-Auth' : 'Pre-Registered',
        stPost: false,
        stPaid: false,
        stExgratia: false,
        stHighPlan: false,
        createdBy: user.currentUser?.email,
        idBenefit: data.appBasic.benefitDetail.id,
        benefitCode: data.appBasic.benefitDetail.benefitCode,
        benefitName: data.appBasic.benefitDetail.benefitName,
        member: {
          memberId: patientData?.memberId,
          memberName: patientData?.memberName,
          cardNumber: patientData?.cardNumber,
          nik: patientData?.nik,
          dateOfBirth: patientData?.dateOfBirth,
          gender: patientData?.gender,
          maritalStatus: patientData?.maritalStatus,
          memberType: patientData?.memberType,
          memberStatus: patientData?.memberStatus,
          isSuspended: patientData?.isSuspended,
          isVip: patientData?.isVip,
          isAso: patientData?.isAso,
          isIndividual: patientData?.isIndividual,
          joinDate: patientData?.joinDate,
          policyNumber: patientData?.policyNo,
          policyStart: patientData?.policyStart,
          policyEnd: patientData?.policyEnd,
          planCode:
            data.appBasic.benefitDetail.planCode ||
            data.appBasic.benefitDetail.planName ||
            data.appBasic.plan,
          planName: data.appBasic.benefitDetail.planName || data.appBasic.plan,
          insurerCode: patientData?.insurerCode,
          insurerName: patientData?.insurerName,
          remark: patientData?.remark,
          customerCode:
            patientData?.type === 'aso' || patientData?.type === 'group insurance'
              ? patientData?.corporateCode
              : patientData?.insurerCode,
          customerName:
            patientData?.type === 'aso' || patientData?.type === 'group insurance'
              ? patientData?.corporateName
              : patientData?.insurerName,
          memberInsuranceNumber: patientData?.memberInsuranceNumber,
        },
        benefitDetail: data.appBasic.benefitDetail,
        treatmentType: data.appBasic.treatmentType,
        // plannedTreatmentDate: data.appBasic.tanggalRencanaPerawatan,
      }

      // Only include indate if it has a value
      if (data.appBasic.indate && data.appBasic.indate.trim() !== '') {
        requestBody.indate = data.appBasic.indate
      }

      if (
        data.appBasic.tanggalRencanaPerawatan &&
        data.appBasic.tanggalRencanaPerawatan.trim() !== ''
      ) {
        requestBody.plannedTreatmentDate = data.appBasic.tanggalRencanaPerawatan
      }

      // Proceed with the actual claim creation
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/CreateClaim`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              `Bearer ${auth?.token}` ||
              `Bearer ${user.currentUser?.token}` ||
              `Bearer ${user.currentUser?.token}`,
          },
          body: JSON.stringify(requestBody),
        }
      )

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const result = await response.blob()
      const url = window.URL.createObjectURL(result)
      const a = document.createElement('a')
      a.href = url
      a.download = 'submission.pdf'
      document.body.appendChild(a)
      a.click()
      a.remove()

      toast.success('Submission Successful!')
      // Call the success callback to refresh data
      if (onSuccessSubmit) {
        onSuccessSubmit()
      }
      handleClose()
    } catch (error) {
      console.error('Error:', error)
      toast.error('An error occurred during submission')
    } finally {
      setLoading(false)
    }
  }

  const getModalClass = () => {
    // return currentStep === 3
    return currentStep === 4
      ? 'modal-dialog modal-dialog-centered modal-fullwidth'
      : 'modal-dialog modal-dialog-centered mw-900px'
  }

  const validateExclusionProduct = async () => {
    if (!patientData) return false
    // `${process.env.REACT_APP_API_USER_URL}`
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_USER_URL}/api/Data/Provider/ValidateProviderExclusion`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth?.token || user.currentUser?.token}`,
          },
          body: JSON.stringify({
            providerCode: user.currentUser?.providerCode,
            benefitCode: data.appBasic.benefitDetail.benefitCode,
            planCode: data.appBasic.benefitDetail.planCode,
            productCode: patientData?.productCode,
          }),
        }
      )

      // First try to get the response as text
      const responseText = await response.text()

      let errorResult
      try {
        // Try to parse as JSON
        errorResult = JSON.parse(responseText)
      } catch (parseError) {
        // If it's not valid JSON, use the text as is
        console.error('Failed to parse response as JSON:', parseError)
        errorResult = {message: responseText}
      }

      // Now check if response was successful
      if (!response.ok) {
        console.log('Error result:', errorResult)

        const errorMessage =
          errorResult.message || errorResult.Message || errorResult.error || 'Unknown error'

        if (errorMessage.includes('Exclusion Product')) {
          setExclusionMessage(
            'Member dengan Product ini tidak dapat melakukan klaim pada rumah sakit ini'
          )
          setExclusionMessageBenefit('')
        } else if (errorMessage.includes('Exclusion Sub-Product')) {
          setExclusionMessage(
            'Member dengan Plan ini tidak dapat melakukan klaim pada rumah sakit ini'
          )
          setExclusionMessageBenefit('')
        } else if (errorMessage.includes('Exclusion Benefit')) {
          setExclusionMessageBenefit(
            'Member dengan Manfaat ini tidak dapat melakukan klaim pada rumah sakit ini'
          )
          setExclusionMessage('')
        } else {
          // Handle any other error messages from the server
          setExclusionMessage(errorMessage || 'Terjadi kesalahan saat validasi. Silakan coba lagi.')
          setExclusionMessageBenefit('')
        }
        return false
      }

      // If we got here, response was successful
      return true
    } catch (error) {
      setExclusionMessage('Terjadi kesalahan saat menghubungi server. Periksa koneksi Anda.')
      setExclusionMessageBenefit('')
      return false
    }
  }

  console.log('====currentStep====', currentStep)

  return createPortal(
    <>
      <Modal
        data-testid='create-app-modal'
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName={getModalClass()}
        show={show}
        onHide={handleClose}
        onEntered={loadStepper}
        backdrop={true}
        style={currentStep === 4 ? {maxWidth: '90vw'} : {}}
        centered
        scrollable
      >
        <div
          className='modal-header'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h2 style={{margin: 0}}>Pendaftaran Klaim</h2>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={handleClose}
            style={{
              marginLeft: 'auto', // This will push the button to the right
              cursor: 'pointer',
            }}
          >
            <CloseIcon className='fs-1' />
          </div>
        </div>

        <div className='modal-body py-lg-10 px-lg-10'>
          <div
            ref={stepperRef}
            className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
            id='kt_modal_create_app_stepper'
          >
            <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
              <div className='stepper-nav ps-lg-10'>
                {/* Step Navigation */}
                <div className='stepper-item current' data-kt-stepper-element='nav'>
                  <div className='stepper-wrapper'>
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>1</span>
                    </div>
                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Identifikasi</h3>
                      <div className='stepper-desc'>Data Pasien</div>
                    </div>
                  </div>
                  <div className='stepper-line h-40px'></div>
                </div>

                <div className='stepper-item' data-kt-stepper-element='nav'>
                  <div className='stepper-wrapper'>
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>2</span>
                    </div>
                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Data Perawatan</h3>
                      <div className='stepper-desc'>Isi detail perawatan</div>
                    </div>
                  </div>
                  <div className='stepper-line h-40px'></div>
                </div>

                <div className='stepper-item' data-kt-stepper-element='nav'>
                  <div className='stepper-wrapper'>
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>3</span>
                    </div>
                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Formulir</h3>
                      <div className='stepper-desc'>Isi detail formulir</div>
                    </div>
                  </div>
                  <div className='stepper-line h-40px'></div>
                </div>

                {/* <div className="stepper-item" data-kt-stepper-element="nav">
                  <div className="stepper-wrapper">
                    <div className="stepper-icon w-40px h-40px">
                      <i className="stepper-check fas fa-check"></i>
                      <span className="stepper-number">3</span>
                    </div>
                    <div className="stepper-label">
                      <h3 className="stepper-title">Ketentuan</h3>
                      <div className="stepper-desc">Ketentuan</div>
                    </div>
                  </div>
                  <div className="stepper-line h-40px"></div>
                </div> */}

                <div className='stepper-item' data-kt-stepper-element='nav'>
                  <div className='stepper-wrapper'>
                    <div className='stepper-icon w-40px h-40px'>
                      <i className='stepper-check fas fa-check'></i>
                      <span className='stepper-number'>4</span>
                    </div>
                    <div className='stepper-label'>
                      <h3 className='stepper-title'>Selesai</h3>
                      <div className='stepper-desc'>Tinjau dan Buat</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='flex-row-fluid py-lg-5 px-lg-15'>
              <form noValidate id='kt_modal_create_app_form'>
                <Step1
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  handlePatientDataFetchSuccess={handlePatientDataFetchSuccess}
                  handlePatientDataFetchError={handlePatientDataFetchError}
                  handleClaimValidationSuccess={handleClaimValidationSuccess}
                />
                <Step6
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  handleStep2ValidationSuccess={handleStep2ValidationSuccess}
                  handleStep2ValidationError={handleStep2ValidationError}
                  handleStep6ValidationSuccess={handleStep6ValidationSuccess}
                  handleStep6ValidationError={handleStep6ValidationError}
                  errorMessageProduct={exclusionMessage}
                  errorMessageBenefit={exclusionMessageBenefit}
                />
                <Step2
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  handleStep2ValidationSuccess={handleStep2ValidationSuccess}
                  handleStep2ValidationError={handleStep2ValidationError}
                  errorMessageProduct={exclusionMessage}
                  errorMessageBenefit={exclusionMessageBenefit}
                />
                {/* <Step3
                  data={data}
                  updateData={updateData}
                  hasError={hasError}
                  handleStep3ValidationSuccess={handleStep3ValidationSuccess}
                  handleStep3ValidationError={handleStep3ValidationError}
                /> */}
                <Step4 data={data} updateData={updateData} hasError={hasError} />
                <Step5 />

                {/* Spinner for loading state */}
                <div
                  className='spinner spinner-primary'
                  id='loadingSpinner'
                  style={{display: 'none'}}
                >
                  <span className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </span>
                </div>

                {/* Error Message Claim Display */}
                {(errorMessageClaim || claimValidationLoading) && (
                  <div
                    className='mt-4'
                    style={{
                      border: `1px solid ${claimValidationLoading ? '#059BB6' : '#F15E60'}`,
                      borderRadius: '6px',
                      padding: '10px',
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    <div
                      className='d-flex align-items-center justify-content-between'
                      style={{
                        color: claimValidationLoading ? '#059BB6' : '#F15E60',
                        fontWeight: 'bold',
                      }}
                    >
                      <div className='d-flex align-items-center'>
                        {claimValidationLoading ? (
                          <>
                            <span
                              className='spinner-border spinner-border-sm me-2'
                              role='status'
                              aria-hidden='true'
                            ></span>
                            Validating Claim...
                          </>
                        ) : (
                          <>
                            <KTIcon
                              iconName='cross-circle'
                              className='me-2 custom-red large-icon'
                            />
                            Pasien Memiliki Klaim Aktif
                          </>
                        )}
                      </div>
                    </div>
                    <hr
                      style={{
                        border: `1px solid ${claimValidationLoading ? '#059BB6' : '#F15E60'}`,
                        margin: '10px 0',
                      }}
                    />
                    {claimValidationLoading ? (
                      <div style={{color: '#6c757d'}}>
                        <span style={{color: '#b2b7bf'}}>{patientData?.cardNumber}</span>
                        <br />
                        <p style={{color: '#b2b7bf', marginBottom: '0px'}}>
                          Memvalidasi status klaim member...
                        </p>
                        <p style={{color: '#b2b7bf', marginBottom: '0px'}}>
                          Mohon tunggu sebentar.
                        </p>
                      </div>
                    ) : (
                      <div style={{color: '#333'}}>
                        <span style={{color: '#b2b7bf'}}>{patientData?.cardNumber}</span>
                        <br />
                        <p style={{color: '#b2b7bf', marginBottom: '0px'}}>
                          Member memiliki klaim aktif*
                        </p>
                        <p style={{color: '#b2b7bf', marginBottom: '0px'}}>
                          Mohon hubungi telepon bebas pulsa AXA Financial Indonesia di 021-30019292 untuk
                          respons cepat atau informasi lebih lanjut.
                        </p>
                        <p style={{color: '#b2b7bf', marginBottom: '0px'}}>
                          Klaim aktif adalah klaim non tunai yang belum selesai
                        </p>
                      </div>
                    )}
                  </div>
                )}

                <div className='d-flex flex-stack pt-10'>
                  <div className='me-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                      onClick={prevStep}
                    >
                      <LeftArrowIcon className='me-1' /> Kembali
                    </button>
                  </div>
                  <div>
                    {(currentStep === 0 || currentStep === 1) && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={!isPatientDataFetched || !isClaimValidation}
                      >
                        Lanjut <FaArrowRight className='ms-1 me-0' />
                      </button>
                    )}
                    {currentStep === 2 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={!isStep6Valid}
                      >
                        Lanjut <RightArrowIcon className='ms-1 me-0' />
                      </button>
                    )}
                    {currentStep === 3 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='next'
                        onClick={nextStep}
                        disabled={
                          !data.appBasic.phoneNumber || data.appBasic.phoneNumber.trim() === ''
                        }
                      >
                        Lanjut <FaArrowRight className='ms-1 me-0' />
                      </button>
                    )}
                    {currentStep === 4 && (
                      <button
                        type='button'
                        className='btn btn-lg btn-primary'
                        data-kt-stepper-action='submit'
                        onClick={submit}
                        disabled={loading}
                      >
                        {loading ? 'Loading...' : 'Daftar'}
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
      <ToastContainer />
      <style>
        {`
          .modal-fullwidth {
            width: 75vw;
            max-width: 75vw !important;
            margin: 1.75rem auto !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
          }
          
          .modal-fullwidth .modal-content {
            margin: 0 auto;
            width: 100%;
            overflow-y: auto;
            max-height: 85vh;
          }

          /* Center content in Step2 */
          .step-2 .w-100 {
            max-width: 600px;
            margin: 0 auto;
          }
          
          /* Make form fields fixed width */
          .step-2 .form-control,
          .step-2 .form-select,
          .step-2 textarea {
            width: 80%;
          }

          .modal-body {
            overflow: hidden;
          }
        `}
      </style>
    </>,
    modalsRoot
  )
}

export {CreateAppModal}
